import script from "./StoriesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./StoriesSection.vue?vue&type=script&setup=true&lang=js"

import "./StoriesSection.vue?vue&type=style&index=0&id=b8f32266&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8f32266"]])

export default __exports__